export enum Templates {
  None = 0,
  ExternalDocument = 1,
  DefaultEmail = 2,
  PropertyBulletinEmail = 3,
  DefaultSMS = 4,
  PropertyDetailsSMS = 5,
  PropertyDetailEmail = 6,
  WorkOrderEmail = 99,
  PropertyAccountStatementEmail = 100,
  PropertyInvoiceEmail = 101,
  ReceiptEmail = 102,
  PropertyDevelopmentDetailsEmail = 103,
  PropertySummaryAccountStatementEmail = 104,
  RentDemandEmail = 105,
  RentOverdueReminderEmail = 106,
  RentOverdueReminderSMS = 107,
  AppointmentConfirmationEmail = 108,
  AppointmentConfirmationSMS = 109,
  ContractortStatementEmail = 110,
  PropertyBoardEmail = 111,
  PropertyFeedback = 112,
  PropertyFeedbackRequestEmail = 113,
  PropertyFeedbackRequestSMS = 114,
  AppointmentNotificationEmail = 115,
  AppointmentNotificationSMS = 116,
  MaintenanceRequestRejection = 117,
  PropertyAccountArrearsStatementEmail = 118,
  ConsolidatedAccountArrearsStatement = 119,
  IFAEnquiryEmail = 120,
  ClientLoginRegistration = 121,
  WorkOrderContractorSMS = 122,
  WorkOrderLandlordSMS = 123,
  WorkOrderTenantSMS = 124,
  MarketingPreferencesEmail = 125,
  MarketingPreferencesSMS = 126,
  AppointmentCancellationEmail = 127,
  AppointmentCancellationSMS = 128,
  NewCertificateEmail = 129,
  TenancyCertificates = 130,
  NewPropertyOfferPurchaserEmail = 131,
  NewPropertyOfferPurchaserSMS = 132,
  NewPropertyOfferVendorEmail = 133,
  NewPropertyOfferVendorSMS = 134,
  PropertyOfferAcceptedPurchaserEmail = 135,
  PropertyOfferAcceptedPurchaserSMS = 136,
  PropertyOfferAcceptedVendorEmail = 137,
  PropertyOfferAcceptedVendorSMS = 138,
  PropertyOfferRejectedPurchaserEmail = 139,
  PropertyOfferRejectedPurchaserSMS = 140,
  PropertyOfferRejectedVendorEmail = 141,
  PropertyOfferRejectedVendorSMS = 142,
  PropertyOfferWithdrawnPurchaserEmail = 143,
  PropertyOfferWithdrawnPurchaserSMS = 144,
  PropertyOfferWithdrawnVendorEmail = 145,
  PropertyOfferWithdrawnVendorSMS = 146,
  NewPropertyOfferTenantEmail = 147,
  PropertyOfferAwaitingProofPurchaserEmail = 148,
  PropertyOfferAwaitingProofPurchaserSMS = 149,
  SalesMemorandumEmail = 150,
  IncomingSMS = 151,
  DepositProtectionCertificateEmail = 152,
  SolicitorEnquiryEmail = 153,
  OutlookEmail = 200,
  Brochure = 300,
  EPC = 301,
  ContractorInvoice = 302,
  WorkOrderLandlordEmail = 303,
  WorkOrderTenantEmail = 304,
  Certificate = 305,
  SignableDocument = 306,
  InventoryBaseReport = 307,
  TouchRightReport = 308,
  IDAMLReport = 309,
  DepositProtectionCertificate = 310,
  WorkOrderQuoteReport = 311,
  WorkOrderQuoteRequest = 312,
  PaymentLink = 313,
  PaymentLinkSMS = 314,
  ManualPropertyFeedback = 315,
}
